import PropTypes from 'prop-types'
import React from 'react'
import { withRouter } from 'react-router-dom'

import Alert from 'components/Alert'
import Button from 'components/Button'
import FieldWithInput from 'components/FieldWithInput'
import FormFooter from 'components/FormFooter'
import Input from 'components/Input'
import withAuth from 'components/withAuth'
import paths from 'constants/paths'
import { auth } from 'data'
import assertions from 'utils/assertions'

export class PasswordChangeForm extends React.Component {
  static propTypes = {
    user: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.object,
    ]),
  }

  state = {
    password: '',
    passwordValid: false,
    error: null,
    submitting: false,
  }

  clearError = () => {
    this.setState({ error: null })
  }

  handleSubmit = (e) => {
    e.preventDefault()

    this.clearError()

    auth.updatePassword(this.state.password)
      .then(() => {
        console.log('password updated')

        // TODO: success state
        this.props.history.push(paths.REPORTS)
      })
      .catch((error) => {
        console.log(error)
        this.setState({ error })
      })
  }

  render() {
    const { user } = this.props
    const { passwordValid, error, submitting } = this.state

    // https://www.chromium.org/developers/design-documents/create-amazing-password-forms
    const email = (user && user.email) || ''

    return (
      <form className="PasswordChangeForm" onSubmit={this.handleSubmit}>
        <input type="hidden" name="email" value={email} />
        <input type="hidden" name="username" value={email} />
        <FieldWithInput
          input={Input}
          inputProps={{
            type: 'password',
            autoComplete: 'new-password',
            name: 'password',
            icon: 'lock',
            onFocus: this.clearError,
          }}
          label="Password"
          labelAsPlaceholder
          validate={(e) => assertions.notEmpty(e.target.value)}
          onInvalidChange={() => this.setState({ passwordValid: false })}
          onValidChange={(e) =>
            this.setState({
              password: e.target.value,
              passwordValid: true,
            })
          }
        />
        <FormFooter>
          <Button
            type="submit"
            disabled={!passwordValid || submitting}
            full
            onClick={this.handleSubmit}>
            Change password
          </Button>
        </FormFooter>
        {error &&
          <Alert>
            {error.message}
          </Alert>
        }
      </form>
    )
  }
}

export default withRouter(withAuth(PasswordChangeForm))



// WEBPACK FOOTER //
// ./src/components/PasswordChangeForm/PasswordChangeForm.js